import * as Yup from "yup";

export function isDefined<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

export const nullToUndefined = <T>(value: T | null): T | undefined => {
  return value === null ? undefined : value;
};

export const oneOfEnum = <T>(enumObject: { [s: string]: T } | ArrayLike<T>) =>
  Yup.mixed<T>().oneOf(Object.values(enumObject));

export function normalizeSelectedValues<X extends Record<string, any>>(
  defaultValues: X,
  selectedObject?: Record<string, any>
): X {
  const result: any = {};
  Object.entries(defaultValues).forEach(([key, value]) => {
    if (selectedObject) {
      const selectedVal = selectedObject[key];
      if (selectedVal !== undefined && selectedVal !== null) {
        result[key] = selectedVal;
      } else {
        result[key] = value;
      }
    } else {
      result[key] = value;
    }
  });

  return result as X;
}
